// extracted by mini-css-extract-plugin
export var createdDate = "_hf-1";
export var divider = "_hf-2";
export var headerDivider = "_hf-3";
export var messagesCard = "_hf-0";
export var messagesContainer = "_hf-7";
export var messagesContainerWrapper = "_hf-4";
export var pointerCapturingButtonBoxes = "_hf-a";
export var showLeftPanelButton = "_hf-9";
export var showMoreButton = "_hf-c";
export var showMoreButtonContainer = "_hf-b";
export var summaryTitle = "_hf-6";
export var systemMessageCardWrapper = "_hf-d";
export var topButtons = "_hf-8";
export var withPadding = "_hf-5";